export function scopesTransform(items) {
  return items.filter(scope => scope !== 'app.public').map(newScope => ({
    text: newScope.split('_').join(' '),
    value: newScope,
  }))
}
